var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEcommerce1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    id: "ecommerce",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23 27a1 1 0 0 0-1 1v13a1 1 0 0 0 1 1h21a1 1 0 0 0 1-1V28l.48-.32a1 1 0 0 0 .2-1.49L40.29 20a1 1 0 0 0-1.29-.14l-1.54 1.06-5.62-3.75a1 1 0 0 0-1.36.24l-7 9.59Zm1 13V29h19v2h-7a1 1 0 0 0-1 1v5a1 1 0 0 0 1 1h7v2Zm19-7v3h-6v-3Zm-.08-6H32.13l3.16-2.17a4.83 4.83 0 0 0 3.25 1.06 4.64 4.64 0 0 0 3.16-1.2l1.72 2Zm-3.55-5 1 1.17a2.52 2.52 0 0 1-1.84.71 3.94 3.94 0 0 1-1.5-.27Zm-7.87-2.64 1.38.93a1.69 1.69 0 0 1-1.38.71 10.81 10.81 0 0 1-1.15 0Zm-2.39 3.29a6.19 6.19 0 0 0 2.39.35 3.73 3.73 0 0 0 3-1.61l1.12.75-7 4.86h-2.68Z",
    fill: "#21929b",
    className: "color000000 svgShape"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31 30h2v3h-2zM31 36h2v3h-2zM8 60h35.18a3 3 0 1 0 0-2H8c-2.17 0-4-2.75-4-6s1.83-6 4-6h9.18a3 3 0 1 0 0-2H8c-3.31 0-6 3.59-6 8s2.69 8 6 8zm38-2a1 1 0 1 1-1 1 1 1 0 0 1 1-1zM20 44a1 1 0 1 1-1 1 1 1 0 0 1 1-1zm36-32H35.82a3 3 0 1 0 0 2H56c2.17 0 4 2.75 4 6s-1.83 6-4 6h-3.18a3 3 0 1 0 0 2H56c3.31 0 6-3.59 6-8s-2.69-8-6-8zm-23 2a1 1 0 1 1 1-1 1 1 0 0 1-1 1zm17 14a1 1 0 1 1 1-1 1 1 0 0 1-1 1zm8.5 7.5A3.5 3.5 0 1 0 55 39a3.5 3.5 0 0 0 3.5-3.5zm-5 0A1.5 1.5 0 1 1 55 37a1.5 1.5 0 0 1-1.5-1.5zM61 40H49a1 1 0 0 0-1 1v9.85a1 1 0 0 0 1 1h2V61a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1v-9.15h2a1 1 0 0 0 1-1V41a1 1 0 0 0-1-1zm-1 9.85h-1v-5.77h-2V60h-1V50h-2v10h-1V44.08h-2v5.77h-1V42h10zM3 17h22a1 1 0 0 0 .6-1.8L22 12.5V3a1 1 0 0 0-1-1H7a1 1 0 0 0-1 1v9.5l-3.6 2.7A1 1 0 0 0 3 17zM8 4h12v8H8zm-.67 10h13.34L22 15H6z",
    fill: "#21929b",
    className: "color000000 svgShape"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27 8a3 3 0 0 0-3-3v2a1 1 0 0 1 0 2v2a3 3 0 0 0 3-3Z",
    fill: "#21929b",
    className: "color000000 svgShape"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M28 8c0 2.21-1.35 4-3 4v2c2.76 0 5-2.69 5-6s-2.24-6-5-6v2c1.65 0 3 1.79 3 4ZM10 5h4v2h-4zM10 8h8v2h-8z",
    fill: "#21929b",
    className: "color000000 svgShape"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEcommerce1);
export default __webpack_public_path__ + "static/media/ecommerce (1).f2a35c0b31867ad1497c77e18436828e.svg";
export { ForwardRef as ReactComponent };